import { environment } from './environment';
import { isEmpty } from './isEmpty';

export const isAmazonHost = () =>
  window.location.hostname.includes('amazon.') ||
  process.env.REACT_APP_IS_AMAZON === 'true' ||
  environment.amazonModeEnabled;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isMshop = () => !isEmpty((window as any)?.amazon?.mash);
